(function () {
  'use strict';

  function previousOrders ($http, ordersFactory, Common) {
    function link (scope) {
      function getItems () {
        return scope.items;
      }

      function throwError (err) {
        console.log(err);
      }

      function resetOrderHistoryPreview () {
        delete scope.items;
      }

      function activate (res) {
        scope.items = res.orders;
        scope.getItems = getItems;
        scope.language = pnTopbar.language;

        Common.registerObserver('resetOrderHistoryPreview', resetOrderHistoryPreview);
      }

      if (pnTopbar && pnTopbar.isLoggedIn) {
        ordersFactory.getOrders()
          .then(activate, throwError)
          .catch(throwError);
      }

      scope.$on('changeLanguage', function (ev, language) {
        scope.language = language;
      });
    }

    return {
      'restrict': 'E',
      'templateUrl': 'components/orders/previous-orders/previous-orders.html',
      'link': link
    };
  }


  angular.module('web2print.orders')
    .directive('previousOrders', previousOrders);
})();
